module.exports = __webpack_public_path__ + "3ef5cb614ca0ae8ec5a5abddf069fc05.png";